<template>
  <div>
    <v-container class="events-view" style="padding-top: 60px; max-width: 1442px">
      <v-layout row wrap mt-4 align-center>        
        <v-flex xs12 sm12 md9 class="page-header-body">
          <v-flex xs12>
          <p style="color:#4a4a4a;font-size:29px;font-weight:bolder;text-justify:auto;" class="page-header">
            Events</p>
          </v-flex>
          <v-flex xs12 style="color:#4a4a4a;font-size:18px;font-weight:400;margin:0px;">
          <div style="margin-top:-10px;padding-top:0px;">
            <p style="text-justify:auto;line-height:22px;" class="page-header-subtext page-subtitle">
              Events are great for getting things done and staying in touch with just the people you want.Share photos and videos,
            have conversations, make plans and more.
            </p>
          </div>
        </v-flex>
        </v-flex>
        <v-flex v-if="priviledges.events.create_event" class="create-event-flex" xs12 sm12 md3>
          <v-btn :small="breakpoint === 'xs' || breakpoint === 'sm'" :large="breakpoint !== 'xs' && breakpoint !== 'sm'" class="white my-4" style="height:70px;text-transform:capitalize;float:right;font-size:18px;" :style="{color: styles.general.theme_color_dark}" @click.prevent="openModal">
            <v-icon :medium="breakpoint === 'xs' || breakpoint === 'sm'" :x-large="breakpoint === 'md' || breakpoint === 'lg'">add</v-icon>
            Create an Event
          </v-btn>
        </v-flex> 
      </v-layout>
      <v-layout row  align-center justify-center>
        <v-flex xs12>
          <v-card class="mt-2" style="position:relative;">
            <v-tabs  style="margin-left:0px;padding-left:0px;" grow>
              <v-tab class="white" dark key="tab-1" href="#tab-1">
                <div style="text-transform:capitalize;color:#000;font-size:16px;" :style="{color:styles.general.theme_color_light}" >
                  <v-icon medium>my_location</v-icon>
                  Events
                </div>
              </v-tab>
              <v-tab-item id="tab-1">
                <v-layout column wrap style="height:100%;" >			          
                  <event-timeline @viewEvent="viewEvent" type="events" :event="event" v-for="(event, index) in sortEvents" v-if="(index + 1) <= counter" :key="event.eventKey"></event-timeline> 
                </v-layout>
              </v-tab-item>
            </v-tabs>
            <v-flex xs12 md12 v-if="events.length >= counter" class="load-data-div" style="text-align: center;">
              <v-btn @click.prevent="counterPost()" dark class="load-more">Load More</v-btn>
            </v-flex>
            <new-events-modal groupId="" groupRoute="" type="events" @closeModal="closeModal" :trigger.sync="dialog"/>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <div v-if="selected">
      <event-view-modal :trigger="eventModal" :item="eventData" @closeModal="closeModal"></event-view-modal>
      <update-event-modal @closeModal="closeModal" :trigger.sync="openUpdateEventModal" :item="eventData" />      
    </div>
  </div>
</template>

<script>
  import * as moment from 'moment'
  import Vue from 'vue'
  import NewEventsModal from './homepage/events/NewEventsModal.vue'
  import EventViewModal from './grouppage/events/EventViewModal.vue'
  import EventTimeline from './grouppage/events/EventTimelineComponent.vue'
  import UpdateEventModal from '@/pages/homepage/events/UpdateEventsModel.vue'

  let db = Vue.prototype.$firebase.database()

  export default {
    data () {
      return {
        dialog: false,
        trigger: false,
        eventModal: false,
        events: [],
        items: [],
        count: 0,
        eventData: '',
        activeTab: null,
        openUpdateEventModal: false,
        counter: 10,
        selected: false
      }
    },
    components: {
      NewEventsModal,
      EventViewModal,
      UpdateEventModal,
      EventTimeline
    },
    firebase () {
      return {
        getEvents: db.ref('events')
      }
    },
    computed: {
      styles () {
        return this.$store.getters.getStyles
      },
      user () {
        return this.$store.getters.getUserDetails
      },
      priviledges () {
        return this.$store.getters.getUserPrivileges
      },
      breakpoint () {
        return this.$vuetify.breakpoint.name
      },
      sortEvents () {
        var todayEvents = this.getTodayEvents(this.events)
        var futureEvents = this.getFutureEvents(this.events)
        return todayEvents.concat(futureEvents)
      },
    },
    mounted () {
      var id = window.location.hash.substring(1)
      if (id) {
        this.fetchEvent(id.split('=')[1])
      }
      const payload = {
        meta: {
          'h1': 'Events',
          'title': 'Events',
          'description': 'General Events Page',
          'keywords': '',
          'requiresAuth': true
        }
      }
      document.title = payload.meta.title
      this.$store.commit('setHeaderInfo', payload)

      // const self = this
      // this.$on('togglemodal', (val) => {
      //   this.dialog = val
      // })

      this.$on('closeModal', this.closeModal)

      this.getGroupEventsWithUser()
    },
    methods: {
      getTodayEvents (events) {
        return events.filter(event => {
          const momentNow = moment()
          const eventDate = moment(event.eventdate)
          if (eventDate.diff(momentNow, 'days') === 0) {
            return event
          }
        })
      },
      getFutureEvents (events) {
        return events.filter(event => {
          const momentNow = moment()
          const eventDate = moment(event.eventdate)
          // var eventDate = new Date(event.eventdate)
          // if (dateNow.getTime() < eventDate.getTime() && todayDate !== eventDate.getDate()
          //   && todayMonth <= (eventDate.getMonth() + 1)
          //   && todayYear <= eventDate.getFullYear()
          // ) {
          //   return event
          // }
          if (eventDate.diff(momentNow, 'days') > 0) {
            return event
          }
        })
      },
      closeModal () {
        this.dialog = false
        this.eventModal = false
        this.selected = false
      },
      viewEvent (item) {
        window.location.hash = `id=${item.eventKey}`
        this.eventData = item
        if (this.user.uid === item.uid) {
          this.openUpdateEventModal = true;
        } else {
          this.eventModal = true
        }
        this.selected = true
      },
      eventClick (event, jsEvent, pos) {
        this.viewEvent(event)
      },
      openModal () {
        this.dialog = true
      },
      getGroupEventsWithUser () {
        const self = this
        return this.$firebaseRefs.getEvents
          .orderByChild('approvalStatus')
          .equalTo(1)
          .on('value', function (result) {
          if (result.val()) {
            self.items = []
            self.feed = []
            const results = result.val()
            const eventKeys = Object.keys(results)
            const userIds = self._.uniq(eventKeys.map(event => results[event].uid))
            const userInfo = userIds.map(id => {
              return self.$firebase.database().ref('users/' + id).once('value')
            })
            Promise.all(userInfo)
              .then((users) => {
                users.forEach((user) => {
                  eventKeys.forEach((event) => {
                    if (results[event].uid === user.val().uid) {
                      let item = results[event]
                      item.eventKey = event
                      item.id = event
                      item.avatar = user.val().avatar
                      item.user = {}
                      Object.assign(item.user, user.val() || {})
                      self.items.push(item)
                      self.events = self.items.sort((d1, d2) => new Date(d1.eventdate).getTime() - new Date(d2.eventdate).getTime())
                    }
                  })
                })
              })
          } else {
            self.events = []
          }
        })
      },
      fetchEvent (id) {
        let self = this
        this.$firebase.database().ref(`events/${id}`).once('value', (snap) => {
          const data = snap.val()
          return self.getUserInfo(data.uid, self.count)
            .then((result) => {
              data.user = result.val()
              data.avatar = data.user.avatar
              const event = data
              event.eventKey = id
              self.viewEvent(event)
            })
        })
      },
      counterPost () {
        this.counter = this.counter + 10
      },
      getUserInfo (uid, index) {
        return this.$firebase.database().ref('users/' + uid).once('value')
      },

      getCompanyInformation (cid, index) {
        return this.$firebase.database().ref('companies/' + cid).once('value')
      }
    }
  }
</script>

<style>
    .comp-full-calendar {
        max-width: none !important;
        padding: 0px !important
    }
    
</style>



// WEBPACK FOOTER //
// EventsView.vue?1bc6f93a